
import PageTitle from '../components/pagetitle/PageTitle'; // adjust path as needed


const PrivacyPolicy = () => {
  return (
    <div>
     <PageTitle pageTitle="Legal" pagesub="Privacy Policy" />

   

      <div className="container">
       
          <div className="  pp-content">

            <p className="pp-meta">
              Effective Date: <strong>26 March 2026</strong> &nbsp;·&nbsp; Last Updated: <strong>26 March 2026</strong>
            </p>

            <p>
              This Privacy Policy explains how Print Printers (a division of Citicap Channels Pvt. Ltd.)
              collects, uses, stores and protects your personal information when you use our website,
              request a quote, or engage with us in the course of our printing services. By using our
              website or submitting a quote request, you agree to the practices described in this Policy.
            </p>

            <h2>1. Who We Are</h2>
            <p>
              Print Printers is a book printing export company operating as a division of Citicap
              Channels Pvt. Ltd., registered in New Delhi, India. We provide offset book printing
              and export services to publishers, corporations and creative businesses primarily in
              the United States, United Kingdom, Australia and Canada. References to "Print Printers",
              "we", "us" or "our" in this Policy refer to this entity.
            </p>
            <p>
              <strong>Registered Address:</strong> Citicap Channels Pvt. Ltd., New Delhi, India<br />
              <strong>Data Controller Contact:</strong> print@printprinters.com<br />
              <strong>Website:</strong> printprinters.com
            </p>

            <h2>2. Information We Collect</h2>

            <h3>2.1 Information You Provide Directly</h3>
            <p>
              When you submit a quote request, contact us, or communicate with us by email or
              phone, we may collect:
            </p>
            <ul>
              <li>Full name and job title</li>
              <li>Company or publisher name and website</li>
              <li>Email address and telephone number</li>
              <li>Postal address, city, state and country</li>
              <li>Project details including book title, page count, trim size, quantities, paper specifications, binding and finishing requirements</li>
              <li>Files you upload or email to us in connection with a quote or print job</li>
              <li>Payment-related information where applicable (we do not store card numbers)</li>
              <li>Any other information you choose to include in your communications with us</li>
            </ul>

            <h3>2.2 Information Collected Automatically</h3>
            <p>
              When you visit printprinters.com, our website may automatically collect certain
              technical information including:
            </p>
            <ul>
              <li>Your IP address and approximate geographic location</li>
              <li>Browser type and version</li>
              <li>Operating system</li>
              <li>Pages visited and time spent on each page</li>
              <li>Referring website or source</li>
              <li>Date and time of your visit</li>
            </ul>
            <p>
              This information is collected through standard web server logs and, where applicable,
              cookies or similar tracking technologies. It does not identify you personally unless
              combined with other information you have provided.
            </p>

            <h3>2.3 Cookies</h3>
            <p>Our website may use cookies to improve your experience. We use:</p>
            <ul>
              <li>Essential cookies necessary for the website to function correctly</li>
              <li>Analytics cookies to help us understand how visitors use our site (e.g. Google Analytics)</li>
              <li>Preference cookies to remember your choices</li>
            </ul>
            <p>
              You can control or disable cookies through your browser settings. Disabling certain
              cookies may affect the functionality of the website. We do not use cookies to serve
              advertising or track you across third-party websites.
            </p>

            <h2>3. How We Use Your Information</h2>
            <p>We use the information we collect for the following purposes:</p>
            <ul>
              <li>To respond to and process your quote requests</li>
              <li>To prepare, send and manage print orders on your behalf</li>
              <li>To communicate with you about your project, production updates, proofs and shipment status</li>
              <li>To maintain our business records and invoice history</li>
              <li>To improve our website and services</li>
              <li>To comply with our legal and regulatory obligations</li>
              <li>To prevent fraud and ensure the security of our systems</li>
            </ul>
            <p>
              We do not use your information for automated decision-making or profiling. We do not
              sell your personal information to third parties. We do not use your information for
              advertising or marketing purposes beyond direct communication relating to your
              existing or prospective projects with us.
            </p>

            <h2>4. Legal Basis for Processing (GDPR &amp; UK GDPR)</h2>
            <p>
              For individuals in the European Economic Area or the United Kingdom, our legal basis
              for processing your personal data is:
            </p>
            <ul>
              <li><strong>Contract performance</strong> — processing is necessary to respond to your quote request and to perform our printing and delivery services</li>
              <li><strong>Legitimate interests</strong> — for business record-keeping, service improvement and fraud prevention, where these do not override your rights</li>
              <li><strong>Legal obligation</strong> — where we are required to retain records under applicable law</li>
              <li><strong>Consent</strong> — where you have explicitly opted in to receive marketing communications from us</li>
            </ul>

            <h2>5. How We Share Your Information</h2>
            <p>
              We do not sell or rent your personal information. We may share your information only
              in the following limited circumstances:
            </p>

            <h3>5.1 Service Providers and Partners</h3>
            <p>
              We work with carefully selected third-party service providers to operate our business.
              These may include:
            </p>
            <ul>
              <li>Print production partners and factories who manufacture your books under our supervision and quality control</li>
              <li>Freight forwarders and logistics providers who handle the shipment and customs clearance of your order</li>
              <li>IT and software providers who support our website, email and business systems</li>
              <li>Accountants and professional advisors who help us manage our business</li>
            </ul>
            <p>
              These parties receive only the information necessary to perform their specific function.
              They are bound by confidentiality obligations and are not permitted to use your
              information for any other purpose.
            </p>

            <h3>5.2 Legal Requirements</h3>
            <p>
              We may disclose your information if required to do so by law, court order or government
              authority, or where we believe disclosure is necessary to protect our rights, your
              safety or the safety of others.
            </p>

            <h3>5.3 Business Transfers</h3>
            <p>
              In the event of a merger, acquisition or sale of all or substantially all of our
              assets, your information may be transferred to the acquiring entity. We will notify
              you of any such change and your options at that time.
            </p>

            <h2>6. International Data Transfers</h2>
            <p>
              Print Printers is based in India. If you are located in the European Economic Area,
              United Kingdom, Australia, Canada or the United States, your personal data will be
              transferred to and processed in India. We take appropriate safeguards to ensure that
              such transfers comply with applicable data protection law, including implementing
              standard contractual clauses where required.
            </p>
            <p>
              By submitting a quote request or otherwise engaging with us, you acknowledge that
              your information will be transferred to India for processing.
            </p>

            <h2>7. How Long We Retain Your Information</h2>
            <p>
              We retain your personal information for as long as necessary to fulfil the purposes
              outlined in this Policy, including:
            </p>
            <ul>
              <li><strong>Quote requests and project communications</strong> — 7 years from the date of the last communication, to support re-orders and warranty claims</li>
              <li><strong>Client order records and invoices</strong> — 7 years from the invoice date, as required for tax and accounting purposes</li>
              <li><strong>Website analytics data</strong> — 26 months from collection, in line with standard analytics practice</li>
              <li><strong>Marketing contact lists</strong> — until you withdraw consent or request removal</li>
            </ul>
            <p>
              After the applicable retention period, your information will be securely deleted
              or anonymised.
            </p>

            <h2>8. Your Rights</h2>
            <p>
              Depending on your location, you may have the following rights in relation to your
              personal information:
            </p>
            <ul>
              <li><strong>Right of access</strong> — to request a copy of the personal information we hold about you</li>
              <li><strong>Right to rectification</strong> — to request that we correct any inaccurate or incomplete information</li>
              <li><strong>Right to erasure</strong> — to request that we delete your personal information, subject to our legal obligations</li>
              <li><strong>Right to restrict processing</strong> — to request that we limit how we use your information</li>
              <li><strong>Right to data portability</strong> — to receive your information in a structured, machine-readable format</li>
              <li><strong>Right to object</strong> — to object to processing based on our legitimate interests</li>
              <li><strong>Right to withdraw consent</strong> — where processing is based on consent, to withdraw it at any time</li>
            </ul>
            <p>
              To exercise any of these rights, please contact us at{' '}
              <a href="mailto:print@printprinters.com">print@printprinters.com</a>.
              We will respond within 30 days. We may ask you to verify your identity before
              processing your request.
            </p>
            <p>
              If you are located in the United Kingdom or European Economic Area and are not
              satisfied with our response, you have the right to lodge a complaint with your
              local data protection authority.
            </p>

            <h2>9. Security</h2>
            <p>
              We take appropriate technical and organisational measures to protect your personal
              information against unauthorised access, loss, destruction or alteration. These
              measures include:
            </p>
            <ul>
              <li>Secure email communication for all client file transfers</li>
              <li>Access controls limiting who within our organisation can view your information</li>
              <li>Confidentiality obligations for all staff and third-party partners</li>
              <li>Regular review of our security practices</li>
            </ul>
            <p>
              No method of data transmission or storage is 100% secure. While we strive to protect
              your information, we cannot guarantee absolute security. In the event of a data breach
              that affects your rights and freedoms, we will notify you and the relevant authorities
              as required by law.
            </p>

            <h2>10. Children's Privacy</h2>
            <p>
              Our website and services are not directed at children under the age of 16. We do not
              knowingly collect personal information from children. If you believe we have
              inadvertently collected information from a child, please contact us at{' '}
              <a href="mailto:print@printprinters.com">print@printprinters.com</a> and we will
              delete it promptly.
            </p>

            <h2>11. Third-Party Links</h2>
            <p>
              Our website may contain links to third-party websites. We are not responsible for
              the privacy practices or content of those websites. We encourage you to read the
              privacy policies of any external sites you visit.
            </p>

            <h2>12. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time to reflect changes in our
              practices, legal requirements or the services we offer. When we make material
              changes, we will update the "Last Updated" date at the top of this document and,
              where appropriate, notify you by email. Your continued use of our website or
              services after such changes constitutes your acceptance of the updated Policy.
            </p>

            <h2>13. Contact Us</h2>
            <p>
              If you have any questions, concerns or requests regarding this Privacy Policy or
              the way we handle your personal information, please contact us:
            </p>
            <p>
              <strong>Email:</strong>{' '}
              <a href="mailto:print@printprinters.com">print@printprinters.com</a><br />
              <strong>Phone India:</strong> +91 99100 87788<br />
              <strong>Phone USA:</strong> +1 202 470 0880<br />
              <strong>Address:</strong> Citicap Channels Pvt. Ltd., New Delhi, India<br />
              <strong>Website:</strong> printprinters.com
            </p>
            <p>
              We aim to respond to all privacy-related enquiries within 30 days of receipt.
            </p>

          </div>
        
      </div>

      
    </div>
  );
};

export default PrivacyPolicy;